module.exports = __webpack_public_path__ + "static/img/aboutus.2e192f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus.png
// module id = gXbU
// module chunks = 1